import { render } from "./Workbench.vue?vue&type=template&id=11a75d75&ts=true"
import script from "./Workbench.vue?vue&type=script&lang=ts"
export * from "./Workbench.vue?vue&type=script&lang=ts"

import "./Workbench.vue?vue&type=style&index=0&id=11a75d75&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Workbench.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11a75d75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11a75d75', __exports__)) {
    console.log('reload')
    api.reload('11a75d75', __exports__)
  }
  
  module.hot.accept("./Workbench.vue?vue&type=template&id=11a75d75&ts=true", () => {
    console.log('re-render')
    api.rerender('11a75d75', render)
  })

}


export default __exports__